import { type editor } from "monaco-editor";

/**
 * Opens the suggestion widget while the author types inside a quoted value.
 *
 * Most values RoboQL completes sit inside quotes (`topic_name = "…"`,
 * `msgpaths["…"]`, tag and metadata values), and the monarch grammar tokenizes
 * everything after an opening quote as a string. Monaco defaults `strings` to
 * `off`, which leaves the widget closed inside quotes until the author types a
 * trigger character (`.` or space) or presses Ctrl+Space.
 *
 * `other` and `comments` keep monaco's defaults (`on` and `off`). A string that
 * holds free text also opens the widget whenever the completion provider
 * returns suggestions at the caret; Escape dismisses it.
 */
export const ROBOQL_QUICK_SUGGESTIONS: editor.IQuickSuggestionsOptions = {
  strings: "on",
};
